<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<template>
  <div class="one-column-width">
    <!-- form start -->
    <v-card class="r_tabsform_card mb-5">
      <v-form>
        <v-card-title class="r_form_card_title ext_pdg_to_lvl">
          Employability Profile</v-card-title
        >
        <hr class="r_form_card_top_hr" />
        <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
          Personal Information</v-card-title
        >
        <div class="row px-5 pt-5">
          <div class="col-md-12 col-sm-12">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0 pl-0">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  :class="nameErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'name')"
                  v-model="name"
                  placeholder="Full name"
                  required
                />
                <p v-if="nameErr" class="text-sm text-danger">
                  please enter full name correctly
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="dob"
                  placeholder="Date of birth"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                  required
                />
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="email"
                  class="r_formtabs_inputs m-0 w-100"
                  :class="emailErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'email')"
                  v-model="email"
                  placeholder="Email address"
                />
                <p v-if="emailErr" class="text-sm text-danger">
                  please correct email address
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="number"
                  class="r_formtabs_inputs m-0 w-100"
                  :class="cnicErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'cnic')"
                  v-model="cnic"
                  placeholder="CNIC (without dashes)"
                />
                <p v-if="cnicErr" class="text-sm text-danger">
                  please enter correct cnic number (without dashes)
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 pt-5 mt-4 pl-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl">Current Location:</label> -->
                <input
                  type="number"
                  class="r_formtabs_inputs m-0 w-100"
                  :class="phoneErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'phone')"
                  v-model="phone"
                  placeholder="Contact no."
                />
                <p v-if="phoneErr" class="text-sm text-danger">
                  please enter correct contact number
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 pt-0">
                <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                  >Current Location:</label
                >
                <v-autocomplete
                  v-model="country_id"
                  :class="countryErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'country')"
                  :items="countries"
                  label="Select Country"
                  class="r_formtabs_inputs m-0 w-100"
                  @change="filterCities(country_id)"
                ></v-autocomplete>
                <p v-if="countryErr" class="text-sm text-danger">
                  please select your country
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-12 pt-5 mt-4">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <v-autocomplete
                  v-model="city_id"
                  :class="cityErr == true ? 'validation-error' : 'validated'"
                  @keyup="status($event, 'city')"
                  :items="cities"
                  label="Select City"
                  class="r_formtabs_inputs m-0 w-100"
                ></v-autocomplete>
                <p v-if="cityErr" class="text-sm text-danger">
                  please select your city
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-sm-12 pl-0">
            <vue-editor
              v-model="personal_summary"
              outlined
              class="r_formtabs_text_area m-0 w-100 p-0"
              label="About"
              rows="2"
              placeholder="Personal Summary"
            ></vue-editor>
          </div>
        </div>

        <div class="row row mx-5 px-2">
          <div class="col-lg-12 p-0 pt-5 pb-3">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Area of Expertise:</label
                  > -->
                <multiselect
                  class="slect_home_hero w-100"
                  v-model="area_of_expertise"
                  :class="
                    areaOfExpertiseErr == true
                      ? 'validation-error'
                      : 'validated'
                  "
                  @keyup="status($event, 'areaOfExpertise')"
                  :height="300"
                  :options="jobFunctions"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select area of expertise"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
                <p v-if="areaOfExpertiseErr" class="text-sm text-danger">
                  please select your expertise
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Interested In:</label
                  > -->
                <multiselect
                  class="slect_home_hero w-100"
                  v-model="interested_in"
                  :class="
                    interestedInErr == true ? 'validation-error' : 'validated'
                  "
                  @keyup="status($event, 'interestedIn')"
                  :height="300"
                  :options="jobShifts"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select interested in shifts"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
                <p v-if="interestedInErr" class="text-sm text-danger">
                  please select your interested shifts
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Industry:</label
                  > -->
                <multiselect
                  class="slect_home_hero w-100"
                  v-model="industry"
                  :class="
                    industryErr == true ? 'validation-error' : 'validated'
                  "
                  @keyup="status($event, 'industry')"
                  :height="300"
                  :options="jobIndustries"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select industries"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
                <p v-if="industryErr" class="text-sm text-danger">
                  please select industry
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <multiselect
                  class="slect_home_hero w-100"
                  id="multiselectCities"
                  v-model="selected_cities"
                  :class="
                    selectedCitiesErr == true ? 'validation-error' : 'validated'
                  "
                  @keyup="status($event, 'selectedCities')"
                  :height="300"
                  :options="allCities"
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Willing to relocate"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
                <p v-if="selectedCitiesErr" class="text-sm text-danger">
                  please select cities you are willing to relocate
                </p>
              </div>
            </div>
          </div>
        </div>
        <hr class="r_form_card_top_hr" />
        <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
          Skills</v-card-title
        >
        <div class="row row mx-5 px-2">
          <div class="col-lg-12 p-0 pt-5 pb-3">
            <div
              class="row"
              v-for="(item, index) in skillsForm"
              :key="index"
              refs="skillsForm"
            >
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Position:</label
                  > -->

                <multiselect
                  class="slect_home_hero w-100"
                  id="multiselectCities"
                  v-model="item.job_funcation_ch"
                  :height="300"
                  :options="jobFunctionsCh"
                  :multiple="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Profession"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Select skill/s:</label
                  > -->

                <multiselect
                  class="slect_home_hero overflow-x-h w-100"
                  id="multiselectCities"
                  v-model="item.skill"
                  :height="300"
                  :options="allSkills"
                  :multiple="false"
                  :close-on-select="false"
                  :clear-on-select="false"
                  :preserve-search="true"
                  placeholder="Select Skill"
                  label="value"
                  track-by="value"
                  :preselect-first="false"
                >
                </multiselect>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-primary r_formtabs_inputs_lbl"
                    >Experience in years:</label
                  > -->
                <input
                  type="number"
                  v-model="item.experience"
                  class="r_formtabs_inputs m-0 w-100"
                  placeholder="Experience in years"
                  required
                />
              </div>
              <div class="col-lg-2 col-md-6 col-sm-12 pt-0">
                <!-- <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
                    >add new row</label
                  > -->
                <button
                  class="r_form_add_more_recods_btnnn"
                  type="button"
                  @click="skillsAddNewRow()"
                >
                  Add
                </button>
                <button
                  v-if="index > 0"
                  class="r_cust_del_new_rec_btn"
                  type="button"
                  @click="skillsDeleteRow(index)"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr class="r_form_card_top_hr" />
        <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
          Work Experience</v-card-title
        >
        <h4 class="ml-5 text-primary r_formtabs_inputs_lbl">
          Latest work experience first:
        </h4>

        <div
          class="row p-5"
          v-for="(item, index) in expForm"
          :key="index"
          refs="expForm"
        >
          <div class="col-md-12 col-sm-12">
            <div class="row">
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.companyName"
                  placeholder="Company name"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.designation"
                  placeholder="Designation"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.startingDate"
                  placeholder="Start date"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.endDate"
                  placeholder="End date"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-sm-12">
            <vue-editor
              v-model="item.description"
              outlined
              class="r_formtabs_text_area m-0 w-100 p-0"
              label="About"
              rows="2"
              placeholder="Job description"
            ></vue-editor>
          </div>

          <div class="col-12 pt-0">
            <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
              >add new row</label
            >
            <button
              class="r_form_add_more_recods_btnnn"
              type="button"
              @click="expAddNewRow()"
            >
              Add
            </button>
            <button
              v-if="index > 0"
              class="r_cust_del_new_rec_btn"
              type="button"
              @click="expDeleteRow(index)"
            >
              Delete
            </button>
          </div>
        </div>

        <hr class="r_form_card_top_hr" />
        <v-card-title class="r_form_card_sub_title ext_pdg_to_lvl">
          Certificates</v-card-title
        >
        <h4 class="ml-5 text-primary r_formtabs_inputs_lbl">
          Latest certificate first:
        </h4>

        <div
          class="row p-5"
          v-for="(item, index) in certificateForm"
          :key="index"
          refs="certificateForm"
        >
          <div class="col-md-12 col-sm-12">
            <div class="row">
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.certificateName"
                  placeholder="Company name"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.awardedBy"
                  placeholder="Awarding body name"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.startingDate"
                  placeholder="Start date"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                />
              </div>
              <div class="col-md-3 col-sm-12">
                <!-- <label>Name <span class="text-danger">*</span></label> -->
                <input
                  type="text"
                  class="r_formtabs_inputs m-0 w-100"
                  v-model="item.endDate"
                  placeholder="End date"
                  onfocus="(this.type='date')"
                  onblur="(this.type='text')"
                />
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12 col-sm-12">
                <vue-editor
                  v-model="item.cert_description"
                  outlined
                  class="r_formtabs_text_area m-0 w-100"
                  label="About"
                  rows="2"
                  placeholder="Certificate description"
                ></vue-editor>
              </div> -->
          <div class="col-12 pt-0">
            <label class="ml-5 text-white d-block r_formtabs_inputs_lbl"
              >add new row</label
            >
            <button
              class="r_form_add_more_recods_btnnn"
              type="button"
              @click="certAddNewRow()"
            >
              Add
            </button>
            <button
              v-if="index > 0"
              class="r_cust_del_new_rec_btn"
              type="button"
              @click="certDeleteRow(index)"
            >
              Delete
            </button>
          </div>
        </div>

        <hr class="r_form_card_top_hr" />
        <div class="row m-5 mt-4 pb-4 ml-3">
          <div class="col-md-6">
            <button
              type="button"
              class="r_form_add_more_btnnn m-0"
              @click="formSubmit"
            >
              Save
            </button>
            <router-link
              :to="{ name: 'student-create-profile' }"
              v-slot="{ href, navigate }"
              class="r_form_cancel_more_btnnn m-0"
            >
              <a :href="href" @click="navigate">
                Cancel
              </a>
            </router-link>
          </div>
        </div>
      </v-form>
    </v-card>

    <!-- form end -->
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import GeneralService from "@/MainServices/GeneralService.js";
import IndexService from "@/MainServices/IndexService.js";
import axios from "axios";
import API from "@/core/api";
import Multiselect from "vue-multiselect";
import { VueEditor } from "vue2-editor";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      skillsForm: [
        {
          profession: "",
          job_funcation_ch: "",
          skill: "",
          experience: "",
        },
      ],
      expForm: [
        {
          companyName: "",
          designation: "",
          startingDate: "",
          endDate: "",
          description: "",
        },
      ],
      certificateForm: [
        {
          certificateName: "",
          awardedBy: "",
          startingDate: "",
          endDate: "",
          // cert_description: "",
        },
      ],
      personal_summary: "",
      name: "",
      dob: "",
      email: "",
      cnic: "",
      phone: "",
      country_id: "",
      city_id: "",
      area_of_expertise: [],
      interested_in: [],
      industry: [],
      user_id: 0,
      countries: [],
      allCities: [],
      cities: [],
      selected_cities: [],
      saved_cnic: "",
      jobFunctions: [],
      jobFunctionsCh: [],
      jobShifts: [],
      jobIndustries: [],
      allSkills: [],
      nameErr: false,
      emailErr: false,
      cnicErr: false,
      phoneErr: false,
      countryErr: false,
      cityErr: false,
      areaOfExpertiseErr: false,
      interestedInErr: false,
      industryErr: false,
      selectedCitiesErr: false,
      reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      tokens: [
        "HtDFLJIJNa4mwOEHAw45TLtgLy3Zzi3k85kKZV6p",
        "HtDFLJI54236wOEHAw4grop1Ly3Zzi3k85kKZV6p",
        "HtDF7ybds236wOEHAw4grop1Ly3Zzi3mnbvcZV6p",
        "HtDFpoi8u236wOEHAw4grop1Ly3ZqwertbvcZV6p",
        "HtDFpoi8u236wOE45698rop1Ly3Zqwe52031ZV6p",
        "HtDFpoi8u236wOE45698ropoijhbvcxz2031ZV6p",
        "HtDFpoi8u236wOE45698rop123poi456t031ZV6p",
        "HtDFpoi8u236wOE456qwedsa3456bf8sj031ZV6p",
        "HtDFpoi8u236wOE45698rop12742651erts1ZV6p",
        "HtDFpoi8u236wOE456qwed745632ertuj031ZV6p",
      ],
      token: `Bearer ${localStorage.getItem("token")}`,
      // rules: {
      //   name: [(val) => (val || "").length > 0 || "Name is required"],
      //   email: [(val) => (val || "").length > 0 || "Date of birth is required"],
      // },
    };
  },
  components: { Multiselect, VueEditor },

  methods: {
    status(event, el) {
      const value = event.target.value;

      if (el == "name") {
        if (value == "" || value == null) {
          this.nameErr = true;
        } else {
          this.nameErr = false;
        }
      }

      if (el == "email") {
        if (value == "" || value == null || !this.reg.test(this.email)) {
          this.emailErr = true;
        } else {
          this.emailErr = false;
        }
      }

      if (el == "cnic") {
        if (
          value == "" ||
          value == null ||
          isNaN(value) ||
          value.length != 13
        ) {
          this.cnicErr = true;
        } else {
          this.cnicErr = false;
        }
      }

      if (el == "phone") {
        if (value == "" || value == null || isNaN(value)) {
          this.phoneErr = true;
        } else {
          this.phoneErr = false;
        }
      }

      if (el == "country") {
        if (value == "" || value == null || value.length == 0) {
          this.countryErr = true;
        } else {
          this.countryErr = false;
        }
      }

      if (el == "city") {
        if (value == "" || value == null || value.length == 0) {
          this.cityErr = true;
        } else {
          this.cityErr = false;
        }
      }

      if (el == "areaOfExpertise") {
        if (value == "" || value == null || value.length == 0) {
          this.areaOfExpertiseErr = true;
        } else {
          this.areaOfExpertiseErr = false;
        }
      }

      if (el == "interestedIn") {
        if (value == "" || value == null || value.length == 0) {
          this.interestedInErr = true;
        } else {
          this.interestedInErr = false;
        }
      }

      if (el == "industry") {
        if (value == "" || value == null || value.length == 0) {
          this.industryErr = true;
        } else {
          this.industryErr = false;
        }
      }

      if (el == "selectedCities") {
        if (value == "" || value == null || value.length == 0) {
          this.selectedCitiesErr = true;
        } else {
          this.selectedCitiesErr = false;
        }
      }
    },

    skillsAddNewRow() {
      this.skillsForm.push({
        profession: "",
        job_funcation_ch: "",
        skill: "",
        experience: "",
      });
    },
    skillsDeleteRow(index) {
      this.skillsForm.splice(index, 1);
    },
    expAddNewRow() {
      this.expForm.push({
        companyName: "",
        designation: "",
        startingDate: "",
        endDate: "",
        description: "",
      });
    },
    expDeleteRow(index) {
      this.expForm.splice(index, 1);
    },
    certAddNewRow() {
      this.certificateForm.push({
        certificateName: "",
        awardedBy: "",
        startingDate: "",
        endDate: "",
        // cert_description: "",
      });
    },
    certDeleteRow(index) {
      this.certificateForm.splice(index, 1);
    },

    filterCities(id) {
      IndexService.getCountryWithCities(id).then((res) => {
        this.cities = [];
        res.data.cities.map((el) => {
          this.cities.push({ value: el.id, text: el.city });
        });
      });
    },

    formSubmit() {
      if (
        this.nameErr == false &&
        this.emailErr == false &&
        this.phoneErr == false &&
        this.cnicErr == false &&
        this.countryErr == false &&
        this.cityErr == false &&
        this.areaOfExpertiseErr == false &&
        this.interestedInErr == false &&
        this.industryErr == false &&
        this.selectedCitiesErr == false
      ) {
        let formData = new FormData();
        formData.append("personal_summary", this.personal_summary);
        formData.append("name", this.name);
        formData.append("email", this.email);
        formData.append("cnic", this.cnic);
        formData.append("saved_cnic", this.saved_cnic);
        formData.append("phone", this.phone);
        formData.append("dob", this.dob);
        formData.append("country_id", this.country_id);
        formData.append("city_id", this.city_id);

        GeneralService.saveStdCareerProfle(formData)
          .then((res) => {
            if (res.data) {
              this.name = res.data.name;
              this.email = res.data.email;
              this.user_id = res.data.id;
              this.phone = res.data.contact;
              this.cnic = res.data.cnic;
              this.saved_cnic = res.data.cnic;

              if (res.data.profile != null) {
                this.dob = res.data.profile.dob;
                this.country_id = parseInt(res.data.profile.country);
                this.city_id = parseInt(res.data.profile.city);
                this.personal_summary = res.data.profile.personal_summary;
              }
            }
          })
          .catch((err) => {});

        let cities = [];
        this.selected_cities.map((el) => {
          cities.push(el.value);
        });

        let area_of_expertise = [];
        this.area_of_expertise.map((el) => {
          area_of_expertise.push(el.value);
        });

        let interested_in = [];
        this.interested_in.map((el) => {
          interested_in.push(el.value);
        });

        let industry = [];
        this.industry.map((el) => {
          industry.push(el.value);
        });

        let t = this.tokens[Math.floor(Math.random() * 10)];
        let formData1 = new FormData();
        for (var i = 0; i < cities.length; i++) {
          formData1.append("selected_cities[]", cities[i]);
        }
        for (var i = 0; i < area_of_expertise.length; i++) {
          formData1.append("area_of_expertise[]", area_of_expertise[i]);
        }
        for (var i = 0; i < interested_in.length; i++) {
          formData1.append("interested_in[]", interested_in[i]);
        }
        for (var i = 0; i < industry.length; i++) {
          formData1.append("industry[]", industry[i]);
        }
        formData1.append("email", this.email);
        formData1.append("cnic", this.cnic);
        formData1.append("saved_cnic", this.saved_cnic);
        formData1.append("token", t);
        formData1.append("skills", JSON.stringify(this.skillsForm));
        formData1.append("experiences", JSON.stringify(this.expForm));
        formData1.append("certificates", JSON.stringify(this.certificateForm));

        axios.defaults.headers.common["Authorization"] = this.token;

        axios
          .post(`${API.API_JOB4U}/std-career-profile-store`, formData1)
          .then((res) => {
            Swal.fire({
              title: "",
              text: "Record updated successfully!",
              icon: "success",
              confirmButtonClass: "btn btn-secondary",
              heightAuto: false,
            });
          })
          .catch((err) => {});
      } else {
        Swal.fire({
          title: "",
          text: "Please, provide correct data!",
          icon: "error",
          confirmButtonClass: "btn btn-secondary",
          heightAuto: false,
        });
      }
    },

    fetchDataFromJob4u(e, c) {
      axios.defaults.headers.common["Authorization"] = this.token;
      let t = this.tokens[Math.floor(Math.random() * 10)];

      axios
        .post(`${API.API_JOB4U}/std-career-profile`, {
          token: t,
          email: e,
          cnic: c,
        })
        .then((res) => {
          if (res.data) {
            if (res.data.jobFunctions.length > 0) {
              this.jobFunctions = [];
              this.jobFunctionsCh = [];
              res.data.jobFunctions.map((el) => {
                this.jobFunctions.push({
                  id: el.id,
                  value: el.job_function_name,
                });
                this.jobFunctionsCh.push({
                  id: el.id,
                  value: el.job_function_name,
                  text: el.job_function_name,
                });

                if (
                  res.data.area_of_expertise.indexOf(el.job_function_name) !==
                  -1
                ) {
                  this.area_of_expertise.push({
                    id: el.id,
                    value: el.job_function_name,
                  });
                }
              });
            }

            if (res.data.jobShifts.length > 0) {
              this.jobShifts = [];

              res.data.jobShifts.map((el) => {
                this.jobShifts.push({ id: el.id, value: el.job_shift });

                if (res.data.interested_in.indexOf(el.job_shift) !== -1) {
                  this.interested_in.push({ id: el.id, value: el.job_shift });
                }
              });
            }

            if (res.data.jobIndustries.length > 0) {
              this.jobIndustries = [];
              res.data.jobIndustries.map((el) => {
                this.jobIndustries.push({ id: el.id, value: el.industry_name });

                if (res.data.industry.indexOf(el.industry_name) !== -1) {
                  this.industry.push({ id: el.id, value: el.industry_name });
                }
              });
            }

            this.allCities.map((el) => {
              if (res.data.willing_to_relocate.indexOf(el.value) !== -1) {
                this.selected_cities.push({ id: el.id, value: el.value });
              }
            });

            if (res.data.allSkills.length > 0) {
              res.data.allSkills.map((el) => {
                this.allSkills.push({
                  id: el.id,
                  value: el.skill_name,
                  text: el.skill_name,
                });
              });
            }

            if (res.data.skills.length > 0) {
              this.skillsForm = [];

              for (let i = 0; i < res.data.skills.length; i++) {
                this.skillsForm.push({
                  profession: "",
                  job_funcation_ch: res.data.skills[i].job_funcation_ch,
                  skill: res.data.skills[i].skill,
                  experience: res.data.skills[i].experience,
                });
              }
            }

            if (res.data.work_experience.length > 0) {
              this.expForm = [];
              for (let i = 0; i < res.data.work_experience.length; i++) {
                this.expForm.push({
                  companyName: res.data.work_experience[i].companyName,
                  designation: res.data.work_experience[i].designation,
                  startingDate: res.data.work_experience[i].startingDate,
                  endDate: res.data.work_experience[i].endDate,
                  description: res.data.work_experience[i].description,
                });
              }
            }

            if (res.data.certificate.length > 0) {
              this.certificateForm = [];
              for (let i = 0; i < res.data.certificate.length; i++) {
                this.certificateForm.push({
                  certificateName: res.data.certificate[i].certificateName,
                  awardedBy: res.data.certificate[i].awardedBy,
                  startingDate: res.data.certificate[i].startingDate,
                  endDate: res.data.certificate[i].endDate,
                });
              }
            }
          }
        })
        .catch((err) => {
          // console.log('job4u err', err);
        });
    },
  },
  mounted() {
    IndexService.getCountries().then((res) => {
      this.countries = [];
      res.data.map((el) => {
        this.countries.push({ value: el.id, text: el.country });
      });
    });

    IndexService.getCities().then((res) => {
      this.allCities = [];
      this.cities = [];
      res.data.map((el) => {
        this.allCities.push({ id: el.id, value: el.city });
        this.cities.push({ value: el.id, text: el.city });
      });
    });

    GeneralService.getStdCareerProfle()
      .then((res) => {
        if (res.data) {
          this.name = res.data.name;
          this.email = res.data.email;
          this.user_id = res.data.id;
          if (res.data.contact != null) {
            this.phone = res.data.contact;
          }
          if (res.data.cnic != null) {
            this.cnic = res.data.cnic;
            this.saved_cnic = res.data.cnic;
          }
          this.fetchDataFromJob4u(res.data.email, res.data.cnic);

          if (res.data.profile != null) {
            if (res.data.profile.dob != null) {
              this.dob = res.data.profile.dob;
            }
            this.country_id = parseInt(res.data.profile.country);
            this.city_id = parseInt(res.data.profile.city);
            this.personal_summary = res.data.profile.personal_summary;
          }
        }
      })
      .catch((error) => {
        // console.log("error", error);
      });
  },
};
</script>

<style>
.text-success {
  color: #2eca8b !important;
}
.text-danger {
  color: #a82511 !important;
}
.header-fixed.subheader-fixed.subheader-enabled .wrapper {
  padding-top: 89px !important;
}
</style>
